export var TemplateStatus;
(function (TemplateStatus) {
    TemplateStatus["Published"] = "PUBLISHED";
    TemplateStatus["Archived"] = "ARCHIVED";
    TemplateStatus["Draft"] = "DRAFT";
})(TemplateStatus || (TemplateStatus = {}));
export var FormatOptions;
(function (FormatOptions) {
    FormatOptions["NonNumeric"] = "nonNumeric";
    FormatOptions["All"] = "all";
    FormatOptions["Minimal"] = "minimal";
    FormatOptions["None"] = "none";
})(FormatOptions || (FormatOptions = {}));
export var PythonTransformationOperation;
(function (PythonTransformationOperation) {
    PythonTransformationOperation["PivotTable"] = "pivot_table";
})(PythonTransformationOperation || (PythonTransformationOperation = {}));
